module.exports = __webpack_public_path__ + "static/media/error-icon.b2baaf6c.svg";